<!--Gentry & TBM-->
<template>
  <!--<div v-if="dataNotNull" key="1" class="gentryDiv" style="width: 100%; height: 100%;color:white;">-->
  <div class="container1" style="margin:15px 0 0 10px; height: 100%;">
    <div style="font-size:16px;margin: 10px 0px 20px 25px;text-align: left;font-weight:bold;color:white">Greenmark /
      CONQUAS Status
    </div>
    <el-progress type="circle" :percentage="79" color="blue" :width="135" :stroke-width="12"></el-progress>
  </div>
  <!--</div>-->
  <!--<div v-else key="2" style="width: 100%; height: 100%;">-->
  <!--<div class="title_pro_check">Daily WSH Inspection</div>-->
  <!--<div class="zero_pro_check">No Data !</div>-->
  <!--</div>-->

</template>
<!--<script src="//unpkg.com/vue/dist/vue.js"></script>-->
<!--<script src="//unpkg.com/element-ui@2.10.1/lib/index.js"></script>-->
<script>
import axios from 'axios'
import echarts from 'echarts'


export default {
  props: ['project_id'],
  name: "gentrys",

  data() {
    return {
      my_project_id: this.project_id,
      // color: this.$store.state.color.ch.art_color,
      name: "gentrys",
      // dataNotNull: true,
      // percentage: 50,
      colors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ]
    }
  },
  // mounted() {
  //   var name = window.localStorage.getItem('token_key')
  //   if ("videmo" == name) {
  //     this.my_project_id = "212"
  //   }
  // let postData = {
  //     project_id: this.my_project_id,
  //     user: window.localStorage.getItem("token_key"),
  //     token: window.localStorage.getItem('token')
  // }
  //   axios.post(this.$store.getters.getCmsServer + "DBProjTBMCOPY", postData).then(resp => {
  //     var errNo = resp.data.errno
  //     var errStr = resp.data.errstr_cn
  //     if (errNo == "0") {
  //       this.dataNotNull = true
  //       var result = resp.data.result;
  //       for (var i in result) {
  //         var category = result[i].category
  //         var count = result[i].count
  //         if (category == '1') {
  //           this.staff = count
  //         } else if (category == '0') {
  //           this.workers = count
  //         }
  //       }
  //     } else {
  //       this.dataNotNull = false
  //       this.workers = '0'
  //       this.staff = '0'
  //     }
  //   }).catch(error => {
  //     this.dataNotNull = false
  //     alert(error)
  //   })
  // },
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_pro_tbm
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 10px
  padding-left 25px

.zero_pro_tbm
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/quality/gentry.vue